import { useMatches } from 'react-router';

import type { NavMode } from '../Navigation/NavModeSwitcher';

function navModeFromHandle(handle: unknown): NavMode | undefined {
  if (typeof handle !== 'object' || handle === null || !('navMode' in handle)) {
    return undefined;
  }

  const { navMode } = handle;
  return navMode === 'agent' || navMode === 'code' ? navMode : undefined;
}

/**
 * The nav mode of the page the member is on, or `undefined` when the page
 * belongs to both navs. Declared by `handle: { navMode }` on the branch routes
 * in `appRoutes`; the deepest match wins.
 */
export function useRouteNavMode(): NavMode | undefined {
  const matches = useMatches();

  for (let i = matches.length - 1; i >= 0; i--) {
    const navMode = navModeFromHandle(matches[i].handle);
    if (navMode !== undefined) {
      return navMode;
    }
  }

  return undefined;
}
